import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import styles from './styles.scss';
import { Text } from '@towersystems/towersystems-design-system';
import { getAllPlanNames } from 'state/plan-names/selectors';

const names = (value) =>

    value.split('#').map(function (name, index) {
        return (index==1 ? <span key={index}>{ name.split('-').join(' ').toUpperCase() } </span> : '');
    });

    const planName = (value, serverPlanNames) =>
        Object.keys(serverPlanNames).map(function (key) {

        if(key && value) {
            if(key.toUpperCase() == value.toUpperCase() ) {
                return (serverPlanNames[key] ? <span key={key}>{ serverPlanNames[key].toUpperCase() } </span> : '');
            }
        }
    });

    const PlanName = ({ value, className, planNames, ...rest }) => {
        const resolved = planName(value, planNames).filter(Boolean);
        return (
            <Text weight='medium' size='small' className={classNames(['plan-name', className])}  {...rest}>
                {resolved.length ? resolved : names(value)}
            </Text>
        );
    };

export default connect(
    (state) => ({
        planNames: getAllPlanNames(state),
    }),
    {},
)(PlanName);
